<template>
  <div class="hero">
    <div class="container">
      <div class="hero__wrapper">
        <div class="hero__block">
          <h1 class="hero__title">AweTemplates</h1>
          <p class="hero__text">{{ t('home.hero.subtitle') }}</p>
          <router-link
              :to="translations.i18nRoute({ name: 'store', query: { categoriesSlugs: 'bundles' } })"
              class="hero__button"
          >
            <svg width="184" height="16" viewBox="0 0 184 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M183.031 8.70711C183.422 8.31658 183.422 7.68342 183.031 7.29289L176.667 0.928932C176.277 0.538408 175.644 0.538408 175.253 0.928932C174.863 1.31946 174.863 1.95262 175.253 2.34315L180.91 8L175.253 13.6569C174.863 14.0474 174.863 14.6805 175.253 15.0711C175.644 15.4616 176.277 15.4616 176.667 15.0711L183.031 8.70711ZM0 8V9H182.324V8V7H0V8Z"
                    fill="currentColor"/>
            </svg>
            <span>{{ t('buttons.startNow') }}</span>
          </router-link>
        </div>
        <img class="hero__image" src="@images/heroImage.png" alt="image">
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.hero {
  background-image: url(@images/heroBg.png);
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 75px;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__block {
    display: flex;
    flex-direction: column;
  }

  &__title {
    color: #F3F3F3;
    font-size: 78px;
    font-weight: 700;
    line-height: 130px;
  }

  &__text {
    color: #F3F3F3;
    font-size: 20px;
  }

  &__button {
    cursor: pointer;
    margin-top: 50px;
    display: flex;
    align-items: center;
    gap: 20px;
    background-color: transparent;
    color: #F3F3F3;
    transition: 0.2s;

    & span {
      font-size: 20px;
      font-weight: 700;
      text-decoration: underline;
    }

    @include hover {
      color: #b6b6b6;
    }
  }

  &__image {
    width: 600px;
  }
}

@media (max-width: 1100px) {
  .hero {
    &__title {
      font-size: 52px;
      line-height: 70px;
    }

    &__text {
      font-size: 16px;
    }

    &__button {
      margin-top: 20px;
    }

    &__image {
      width: 400px;
    }
  }
}

@media (max-width: 700px) {
  .hero {
    &__title {
      font-size: 30px;
      line-height: 50px;
    }

    &__text {
      font-size: 12px;
    }

    &__button {
      & svg {
        display: none;
      }

      & span {
        font-size: 16px;
      }
    }

    &__image {
      width: 220px;
    }
  }
}

@media (max-width: 400px) {
  .hero {
    &__image {
      width: 175px;
    }
  }
}
</style>